import { render } from "./ShareNewsDetail.vue?vue&type=template&id=be42a0a4&scoped=true"
import script from "./ShareNewsDetail.vue?vue&type=script&lang=js"
export * from "./ShareNewsDetail.vue?vue&type=script&lang=js"

import "./ShareNewsDetail.vue?vue&type=style&index=0&id=be42a0a4&lang=scss&scoped=true"

import exportComponent from "D:\\digitalnewspaper\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be42a0a4"]])

export default __exports__